import { render, staticRenderFns } from "./CustomerBulkChange.vue?vue&type=template&id=2eca2928&"
import script from "./CustomerBulkChange.vue?vue&type=script&lang=js&"
export * from "./CustomerBulkChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports